<template>
  <div class="zl-admin-products">
    <ul class="uk-subnav uk-subnav-pill uk-flex-center uk-margin-large-bottom">
      <li v-for="item in localMenu"
        :class="{'uk-active': view === item}"
        @click.prevent="switchView(item)">
        <a href="" v-text="item | capitalize"></a>
      </li>
      <li v-for="item in menu">
        <a :href="item.link" v-text="item.name"></a>
      </li>
    </ul>
    <div class="uk-margin uk-text-warning uk-text-center"
      v-if="server.offline"
      v-html="server.status
        ? server.status
        : `We are experiencing temporal connection issues with our server.
          If it persist, please contact our support.`">
    </div>
    <component :is="view"
      keep-alive
      transition="fade"
      transition-mode="out-in">
    </component>
  </div>
</template>

<script>
import Extensions from './Products/Extensions'
import Languages from './Products/Languages'

export default {
  components: {
    Extensions,
    Languages
  },
  data: () => ({
    localMenu: [
      'extensions',
      'languages'
    ]
  }),
  vuex: {
    getters: {
      view: state => state.products.view,
      server: state => state.products.server,
      menu: state => state.menu
    },
    actions: {
      // workaround to add a spinner efect
      // between components loading
      switchView: ({ dispatch }, view) => {
        dispatch('SET_VIEW', 'tm-spinner')
        setTimeout(() => {
          dispatch('SET_VIEW', view)
        }, 1)
      }
    }
  },
  ready: function () {
    this.switchView('extensions')
  }
}
</script>

<style>
/* Transition */
.fade-transition {
  transition: opacity .22s ease;
}
.fade-enter,
.fade-leave {
  opacity: 0;
}
/* Theme */
.tm-row {
  padding-top: 15px;
}
.tm-cursor-default {
  cursor: default;
}
.tm-button-half {
  min-width: 45px !important;
}
.uk-button[disabled]:hover {
  position: static !important;
}
/* Horizontal rule */
.tm-row hr {
  margin: 0;
}
.tm-row:hover hr {
  border-color: #aaa;
}
/* Visibility toggle */
.uk-visible-hover-inline:hover .tm-visible-toggle {
  display: none !important;
  visibility: hidden !important;
}
</style>



/** WEBPACK FOOTER **
 ** Products.vue?5b4ec836
 **/